import React from "react";
import ReactTooltip from 'react-tooltip'
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/lib/withStyles';
import {preferredCountries, errorMessagesObject} from '../Commons/Constants';
import flags from '../../images/flags.png';

import defaultAvatar from '../../images/default-avatar.jpg';

export default (props) => {

    const {
        formEdit,
        currentUser,
        errorMessages,
        handleImageChange,
        handlePhoneChange,
        handlePhoneBlur,
        onEdit,
        onSubmit,
        handleOnChange,

        confirmations,
        confirmationCode,
        getConfirmationCode,
        handleConfirmationCode,
    } = props;

    const {
        phone_key,
        phone_additional_key,
        email_code_sended,
        phone_code_sended,
        phone_additional_code_sended,
        phone_sms_time,
        phone_additional_sms_time,
    } = confirmations;

    let passwordString = props.password.length > 0 ? props.password : props.passwordDefault;

    return  (
        <div className="white-block-content personal-data-form">
            <ul
                className="data-with-labels">
                <li className="avatar">
                    <label htmlFor="">Аватар</label>
                    {
                        props.avatar
                        ? <img src={`${props.avatar}`} alt=""/>
                        : <img src={`${defaultAvatar}`} alt=""/>
                    }

                    {
                        formEdit
                        ?                         
                        <input
                            disabled={formEdit ? false : true}
                            className="value"
                            type="file"
                            accept="image/jpeg,image/png"
                            onChange={handleImageChange}
                            onClick={(event)=> { 
                                    event.target.value = null
                            }}
                        />
                        : null
                    }
                    { 
                        errorMessages && errorMessages.avatar 
                        ? errorMessages.avatar.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }   

                </li>
                <li>
                    <label htmlFor="">Фамилия</label>
                    <input
                        type="text"
                        className="value"
                        disabled={formEdit ? false : true}
                        value={props.last_name}
                        placeholder="Фамилия"
                        onChange={(e) => handleOnChange(e.target.value, 'last_name')}
                        />
                    {
                        errorMessages && errorMessages.last_name 
                        ? errorMessages.last_name.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }                                
                </li>
                <li>
                    <label htmlFor="">Имя</label>
                    <input
                        type="text"
                        className="value"
                        disabled={formEdit ? false : true}
                        value={props.first_name}
                        placeholder="Имя"
                        onChange={(e) => handleOnChange(e.target.value, 'first_name')}
                        />
                    {
                        errorMessages && errorMessages.first_name 
                        ? errorMessages.first_name.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }                                 
                </li>
                <li>
                    <label htmlFor="">Отчество</label>
                    <input
                        type="text" 
                        className="value"
                        disabled={formEdit ? false : true}
                        value={props.patronymic_name}
                        placeholder="Отчество"
                        onChange={(e) => handleOnChange(e.target.value, 'patronymic_name')}
                        />
                    {
                        errorMessages && errorMessages.patronymic_name 
                        ? errorMessages.patronymic_name.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }
                </li>

                <li>
                    <label htmlFor="">Телефон</label>
                    {
                        errorMessages && errorMessages.phone 
                        ? errorMessages.phone.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }
                    <div style={{display:'flex',alignItems:'center',position:'relative'}}>
                        <ReactTelInput
                            classNames="react-my-tel"
                            preferredCountries={preferredCountries}
                            defaultCountry="ru"
                            flagsImagePath={flags}
                            onChange={(val, val2) => handlePhoneChange(val, val2, 'phone')}
                            value={props.phone}
                            disabled={props.phoneDisabled}
                            onBlur={(val, val2) => handlePhoneBlur(val, val2, 'phone')}
                            />

                        
                        <div style={{position:'absolute', right:0,zIndex:6}}>
                            <span className={`info-tooltip confirmed__icon ${currentUser.is_phone_confirmed ? 'active' : ''}`} data-tip data-for='phone' />
                            <ReactTooltip id='phone' type='dark'>
                                <span>
                                    {
                                        currentUser.is_phone_confirmed
                                        ? 'Телефонный номер подтвержден'
                                        : 'Телефонный номер не подтвержден'
                                    }
                                </span>
                            </ReactTooltip>
                        </div>
                    </div>
                    
                    {
                        props.fieldErrors.phone
                        ? <span className="input-error-text">{errorMessagesObject.phone}</span>
                        : null
                    }
                    {
                        errorMessages && errorMessages.phone 
                        ? errorMessages.phone.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }

                   
                    {
                        !formEdit && !currentUser.is_phone_confirmed && phone_code_sended && phone_sms_time > 1 ?
                        <div style={{marginTop: '10px'}}>
                            <input
                                type="number" 
                                className="value"
                                value={phone_key}
                                placeholder="Введите код"
                                onChange={(e) => handleConfirmationCode('phone_key', e.target.value)}
                            />

                            <a href="" className="small-button small-button-border"
                                onClick={(e) => confirmationCode(e, "phone")}>
                                <button>Подтвердить</button>
                            </a>
                            
                        </div>
                        : null
                    }

                    {
                        !formEdit && !currentUser.is_phone_confirmed && phone_code_sended && phone_sms_time > 1 ?
                        <div style={{marginTop: '10px'}}>
                            <div style={{color: '#64ab15'}}>Вам отпрален СМС-код.</div>
                            <div style={{color: '#93959c'}}>СМС-код активен в течении {phone_sms_time} сек.</div>
                        </div>
                        : null
                    }

                    {
                        !formEdit && !currentUser.is_phone_confirmed && phone_sms_time < 1 ?
                        <div className="conf-text-button"
                            onClick={() => getConfirmationCode("phone")}>
                            {
                                phone_code_sended
                                ? 'Отправить еще раз'
                                : 'Отправить код подтверждения'
                            }
                        </div>
                        : null
                    }
                </li>

                <li>
                    <label htmlFor="">Доп. телефон</label>
                    <div style={{display:'flex',alignItems:'center',position:'relative'}}>
                        <ReactTelInput
                            classNames="react-additional-tel"
                            preferredCountries={preferredCountries}
                            defaultCountry="ru"
                            flagsImagePath={flags}
                            onChange={(val, val2) => handlePhoneChange(val, val2, 'phone_additional')}
                            value={props.phone_additional}
                            disabled={props.phoneDisabled}
                            onBlur={(val, val2) => handlePhoneBlur(val, val2, 'phone_additional')}
                            />

                        <div style={{position:'absolute', right:0,zIndex:6}}>
                            <span className={`info-tooltip confirmed__icon ${currentUser.is_phone_additional_confirmed ? 'active' : ''}`} data-tip data-for='phone-add' />
                            <ReactTooltip id='phone-add' type='dark'>
                                <span>
                                    {
                                        currentUser.is_phone_additional_confirmed
                                        ? 'Телефонный номер подтвержден'
                                        : 'Телефонный номер не подтвержден'
                                    }
                                </span>
                            </ReactTooltip>
                        </div>
                    </div>

                    {
                        props.fieldErrors.phone_additional
                        ? <span className="input-error-text">{errorMessagesObject.phone}</span>
                        : null
                    }
                    {
                        errorMessages && errorMessages.phone_additional 
                        ? errorMessages.phone_additional.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }


                    {
                        !formEdit && !currentUser.is_phone_additional_confirmed && phone_additional_code_sended && phone_additional_sms_time > 1 ?
                        <div style={{marginTop: '10px'}}>
                            <input
                                type="number" 
                                className="value"
                                value={phone_additional_key}
                                placeholder="Введите код"
                                onChange={(e) => handleConfirmationCode('phone_additional_key', e.target.value)}
                            />

                            <a href="" className="small-button small-button-border"
                                onClick={(e) => confirmationCode(e, "phone_additional")}>
                                <button>Подтвердить</button>
                            </a>
                            
                        </div>
                        : null
                    }

                    {
                        !formEdit && !currentUser.is_phone_additional_confirmed && phone_additional_code_sended && phone_additional_sms_time > 1 ?
                        <div style={{marginTop: '10px'}}>
                            <div style={{color: '#64ab15'}}>Вам отпрален СМС-код.</div>
                            <div style={{color: '#93959c'}}>СМС-код активен в течении {phone_additional_sms_time} сек.</div>
                        </div>
                        : null
                    }

                    {
                        !formEdit && !currentUser.is_phone_additional_confirmed && phone_additional_sms_time < 1 ?
                        <div className="conf-text-button"
                            onClick={() => getConfirmationCode("phone_additional")}>
                            {
                                phone_additional_code_sended
                                ? 'Отправить еще раз'
                                : 'Отправить код подтверждения'
                            }
                        </div>
                        : null
                    }
                </li>

                <li>
                    <label htmlFor="">Электронная почта</label>
                    <div style={{display:'flex',alignItems:'center',position:'relative'}}>
                        <input
                            type="text"
                            className="value"
                            style={{width:'100%'}}
                            disabled={formEdit ? false : true}
                            value={props.username}
                            placeholder="Электронная почта"
                            onChange={(e) => handleOnChange(e.target.value, 'username')}
                        />

                        <div style={{position:'absolute',right:0}}>
                            <span className={`info-tooltip confirmed__icon ${currentUser.is_email_confirmed ? 'active' : ''}`} data-tip data-for='email' />
                            <ReactTooltip id='email' type='dark'>
                                <span>
                                    {
                                        currentUser.is_email_confirmed
                                        ? 'Электронная почта подтверждена'
                                        : 'Электронная почта не подтверждена'
                                    }
                                </span>
                            </ReactTooltip>
                        </div>
                    </div>

                    {
                        (formEdit || currentUser.is_email_confirmed) ? null :
                        <div className="conf-text-button"
                            onClick={() => getConfirmationCode("email")}>
                            {
                                email_code_sended
                                ? 'Отправить еще раз'
                                : 'Отправить код подтверждения'
                            }
                        </div>
                    }

                    {
                        errorMessages && errorMessages.email 
                        ? errorMessages.email.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }
                </li>
                <li>
                    <label htmlFor="">Пароль</label>
                    <input
                      //  type="password"
                        type="text"
                        className="value my-mask"
                        disabled={formEdit ? false : true}
                        value={formEdit ? props.password : passwordString}
                        onChange={(e) => handleOnChange(e.target.value, 'password')}
                        placeholder="Пароль"
                        />
                    {
                        errorMessages && errorMessages.password 
                        ? errorMessages.password.map((text, index) =>
                            <span key={index} className="input-error-text">{text}</span>
                        )
                        : ''
                    }  
                </li>
            </ul>

            <div className="actions ">
                <div className="big-button empty-button">
                    <button onClick={() => props.onEdit()}>
                        {formEdit ? 'Отмена' : 'Редактировать'}
                    </button>
                </div>
                {
                    formEdit
                    ?                         
                    <div className="big-button">
                        <button onClick={(e) => onSubmit(e)}>Сохранить</button>
                    </div>
                    : null
                }
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Account/PersonalDataForm.js